<template>
  <div class="confirm-payment" :class = "{'clear-header':isWechatBrowser}">
    <my-header class="top-title" v-if="!isWechatBrowser" title="确认支付" :showBack="true"></my-header>
    <div class="bill-list">
      <div class="bill-item" v-for="fee in projectStageFee" v-if="(fee.type != '3') || (fee.type == '3' && fee.priceStage > 0)">
        <div class="bill-info">
          <div class="bill-name">{{fee.name || '合同款'}}</div>
          <div class="bill-status-uncreate" v-if="!fee.priceStage" >等待工长发起</div>
          <div class="bill-status-prepay" v-if="fee.status == '0' && fee.priceStage">待支付</div>
          <div  class="bill-status-prepay" v-if="stageFee.id == fee.id && customerPayVoucher.stageFeeId == fee.id">{{payVoucherStatus}}</div>
          <div  class="bill-status-paid" v-if="fee.status == '1'">已支付</div>
        </div>
        <div class="bill-status-uncreate" v-if="!fee.priceStage">待生成</div>
        <div class="bill-amount" v-if="fee.priceStage">￥{{fee.priceStage}}</div>
      </div>
    </div>
    <div v-if="stageFee.payType == '3'" class="pay-mode">
      <div class="mode-row" style="justify-content: space-between;padding-top: 0.15rem">
        <div>业主支付金额</div>
        <div style="width: 2.4rem;height: 0.9rem;">
          <input v-model="amount" type="number" placeholder="请输入项目款" class="mint-field-core" style="height: 0.9rem;background-color: #f3f8fc;text-align: center">
        </div>
      </div>
      <div class="mode-row"><img class="icon" src="../../assets/icon/icon-selected.png">上传凭证</div>
      <div class="record-img">
        <div class="image-area">
          <div class="image-view">
            <div v-if="voucher">
              <div class="image" style="position: relative">
                <img :src="imgUrl+voucher" @click.stop="optionImage($event)">
              </div>
            </div>
            <div v-if="!voucher">
              <div class="image add-image" @click.stop="addImage()">
                <span class="icon-plus"><img src="../../assets/icon/icon-plus.png"></span>
                <span style="display: none;"><input type="file" class="image-input" multiple accept="image/*"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mode-row border-top-style">
        <span class="row-money">金额：</span><span class="money">{{amount}}元</span>
      </div>
    </div>
    <div v-if="stageFee.payType == '1'" class="pay-mode">
      <div class="mode-row" style="justify-content: space-between;padding-top: 0.15rem">
        <div>业主支付金额</div>
        <div style="width: 2.4rem;height: 0.9rem;">
          <input v-model="amount" type="number" placeholder="请输入项目款" class="mint-field-core" style="height: 0.9rem;background-color: #f3f8fc;text-align: center">
        </div>
      </div>
      <div v-if="payTypeSelected == 'UPLOADVOUCHER'"  @click = "selectUploadVoucher('WECHAT')" class="mode-row"><img class="icon" src="../../assets/icon/icon-selected.png">上传凭证</div>
      <div v-if="payTypeSelected != 'UPLOADVOUCHER'"  @click = "selectUploadVoucher('UPLOADVOUCHER')" class="mode-row"><img class="icon" src="../../assets/icon/icon-unselected.png">上传凭证</div>
      <div class="record-img">
        <div class="image-area">
          <div class="image-view">
            <div v-if="voucher">
              <div class="image" style="position: relative">
                <img :src="imgUrl+voucher" @click.stop="optionImage($event)">
              </div>
            </div>
            <div v-if="!voucher">
              <div class="image add-image" @click.stop="addImage()">
                <span class="icon-plus"><img src="../../assets/icon/icon-plus.png"></span>
                <span style="display: none;"><input type="file" class="image-input" multiple accept="image/*"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mode-row border-top-style">
        <span class="row-money">金额：</span>
        <span class="money">{{amount}}元</span>
      </div>
    </div>
    <div class="btns">
      <div class="cancel-btn" @click="goback()">取 消</div>
      <div class="payment-btn" @click="savePayVoucher()">提交凭证</div>
      <div class="payment-btn" v-if="isPay">已支付</div>
    </div>
    <mt-actionsheet :actions="actions" v-model="sheetVisible"></mt-actionsheet>

    <div v-if="showBig" class="big-img-container" @click="hideImageView()">
      <img class="big-img"  :src="showImage">
      <div class="hidden-tip">轻触屏幕返回</div>
    </div>
  </div>
</template>

<script>
  import {imgUrl} from '../../config'
  import {Indicator, MessageBox, Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import session from '../../utils/Session'
  import ProjectService from '../../service/customer/ProjectService'
  import coreCodeService from '../../service/core/CodeService'
  import baseService from '../../service/BaseService'
  import payUtil from '../../utils/Pay'
  import customerPayVoucherService from '../../service/customer/CustomerPayVoucherService'

  export default {
    name: 'ConfirmPayment',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        imgUrl:imgUrl,
        onestopProject:{},
        stageFee:{},
        projectStageFee:[],
        payConfig:{},
        wxPayParams:{},
        isPay:false,
        codeCategory:'sysPayType',
        payTypeList:[],
        voucher:'',
        payTypeSelected:'WECHAT',
        sheetVisible:false,
        actions:[],
        showImage:'',
        showBig:false,
        customerProject:{tradeSettlement:{}},
        customerPayVoucher:{},
        payVoucherStatus:'',
        isWechatBrowser:this.$verfyBrowserType(),
        prePayInfo:{},
        amount:''
      }
    },
    created(){
      this.onestopProject.id =this.$route.query.id;
      this.onestopProject.customerProjectId =this.$route.query.customerProjectId;
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.getProjectStageFee();
      this.getCustomerProject();
      this.getSysPayType();
    },
    methods: {
      goback () {
        this.$router.go(-1);
      },
      async getSysPayType(){
        let {code,msg,data} = await coreCodeService.getCodeList(this.codeCategory,'1');
        if(code == '0'){
          this.payTypeList = data;
          if(this.payTypeList.length>1){
            for(let i = 0;i < this.payTypeList.length;i++){
              if(i == 0){
                this.$set(this.payTypeList[i],'selected',true);
              }else {
                this.$set(this.payTypeList[i],'selected',false);
              }
            }
          }else {
            this.payTypeSelected = this.payTypeList[0].key;
          }
        }else {
          Toast('获取系统支付方式失败');
        }
      },
      async getProjectStageFee(){//整包项目的收费列表
        var result = await ProjectService.getOnestopProjectStageFee(this.onestopProject.id,session.getAccountToken().token);
        if(result.code == 0){
          this.projectStageFee=result.data.projectStageFeeList;
          for(let psf of this.projectStageFee){
            if(psf.status != '1'){
              this.stageFee = psf;
              this.amount = this.stageFee.priceStage;
              break;
            }
          }
          if(this.stageFee.payType == '3'){
            this.payTypeSelected = 'UPLOADVOUCHER';
            let {code,msg,data} = await customerPayVoucherService.newest(this.onestopProject.id);
            if(code == '0'){
              this.customerPayVoucher = data;
              if(this.customerPayVoucher.checkStatus == '1'){
                this.payVoucherStatus = '凭证待审核';
              } else if(this.customerPayVoucher.checkStatus == '3'){
                this.payVoucherStatus = '凭证审核不通过';
              }
            }
          }
        }else {
          Toast('获取收费列表信息失败');
        }
      },
      selectUploadVoucher(type){
        this.payTypeSelected = type;
      },
      async getCustomerProject(){//获取预约项目所对应的服务类型（整包项目、预约项目类型不一致）
        var result=await ProjectService.getCustomerProjectDetail(this.onestopProject.customerProjectId);
        if(result.code == '0'){
          this.customerProject = result.data;
        }
      },
      async sendWxPayOrder(){
        //判断浏览器类型
        let ua = navigator.userAgent.toLowerCase();
        if(ua.match(/MicroMessenger/i) == 'micromessenger') {
          let browserType = '1';
          var result = await ProjectService.customerPay(this.onestopProject.id,session.getAccountToken().id,this.customerProject.type);
          if(result.code == '0'){
            this.prePayInfo = payUtil.pay(result.data.prepayId,result.data.nonceStr);
            let requestPay = this.requestPay;
            if (typeof WeixinJSBridge == "undefined"){
              if( document.addEventListener ){
                document.addEventListener('WeixinJSBridgeReady', requestPay, false);
              }else if (document.attachEvent){
                document.attachEvent('WeixinJSBridgeReady', requestPay);
                document.attachEvent('onWeixinJSBridgeReady', requestPay);
              }
            }else{
              this.requestPay();
            }
          } else {
            Toast(result.msg);
          }
        }else {
          let browserType = '2';
          let result = await ProjectService.customerPay(this.onestopProject.id,session.getAccountToken().id,this.customerProject.type);
          if(result.code == '0'){
            let payCallBackUrl = result.data.mWebUrl + '&redirect_url=' + window.location.href;
            window.location.href = payCallBackUrl;
          }else {
            Toast(result.msg);
          }
        }
      },
      async savePayVoucher(){
        let checkUserId = this.customerProject.foremanId;
        if(this.amount <= 0){
          Toast('请输入大于0的金额!');
          return false;
        }
        if(!this.voucher){
          Toast('请上传支付凭证!');
          return false;
        }

        let customerPayVoucher = {projectId:this.onestopProject.id,projectType:this.customerProject.type,voucher:this.voucher,stageFeeId:this.stageFee.id,amount:this.amount,checkUserId};
        let {code,msg,data} = await customerPayVoucherService.save(customerPayVoucher);
        if(code == '0'){
          Toast('上传支付凭证成功!');
          this.$router.go(-1);
        }else {
          Toast(msg);
        }
      },
      requestPay(){
        let prePayInfo = this.prePayInfo;
        let that = this;
        try {
          WeixinJSBridge.invoke(
            'getBrandWCPayRequest',
            {
              "appId":prePayInfo.appId,     //公众号名称，由商户传入
              "timeStamp":prePayInfo.timeStamp,         //时间戳，自1970年以来的秒数
              "nonceStr":prePayInfo.nonceStr, //随机串
              "package":prePayInfo.package,
              "signType":prePayInfo.signType,         //微信签名方式：
              "paySign":prePayInfo.paySign //微信签名
            },
            function(res){
              if(res.err_msg == "get_brand_wcpay_request:ok" ) {
                that.$router.go(-1);
              } else if(res.err_msg == "get_brand_wcpay_request:cancel" ){
                console.info("取消支付");
              }else {
                Toast('支付失败!');
                that.errorMsg = JSON.stringify(res)
              }// 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回    ok，但并不保证它绝对可靠。
            },function (e) {
              console.error("支付失败err!"+JSON.stringify(e));
              Toast("支付失败!"+JSON.stringify(e));
            });
        }catch (e){
          console.error("支付失败-----!"+JSON.stringify(e));
          Toast("支付失败!"+JSON.stringify(e));
        }
      },
      async addImage(){
        if(this.payTypeSelected != 'UPLOADVOUCHER'){
          Toast('请先选择上传凭证支付方式');
        }else {
          //小程序选择文件
          if(!!this.global.isMiniProgrm){
            baseService.uploadImageWxMini().then(res =>{
              //处理image,key
              baseService.downImage({mediaId:res}).then((data)=>{
                //处理image,key
                this.voucher = data.name;
                Indicator.close();
              });
            }).catch(err =>{
              console.log("上传文件失败========",err);
              Indicator.close();
            });
          }else {
            //使用input文件选择
            let fileInput = document.querySelector(".image-input");
            fileInput.click();
            let that = this;
            fileInput.onchange = function(){
              let file = this.files[0];
              if(this.outerHTML){
                this.outerHTML=this.outerHTML;
              }else{      //FF
                this.value="";
              }
              Indicator.open({
                text: '加载中...',
                spinnerType: 'fading-circle'
              });
              lrz(file,{width: 1024,fieldName:'imgFile',quality:0.6}).then((rst) =>{
                return baseService.uploadImage(file);
              }).then((data) => {
                //处理image,key
                that.voucher = data.name;
              }).catch((err) =>{
                console.log("上传文件失败========",err);
              }).always(()=>{
                Indicator.close();
              });
            }
          }
        }
      },
      optionImage(imageType,index){
        var that = this;
        this.actions = [
          {
            name: '查看',
            method: () =>{
              this.previewImage(imageType,index);
            }
          },
          {
            name: '删除',
            method: () =>{
              this.deleteImage(imageType,index);
            }
          }];
        this.sheetVisible = true;
      },
      deleteImage(){
        var that= this;
        MessageBox.confirm('确定要删吗？删除后将无法恢复。')
          .then((action) => {
            that.voucher = '';
          }).catch(e =>{
          console.error("删除图片出错：",e);
        });
      },
      previewImage(){
        this.showImage = imgUrl+this.voucher;
        this.showBig = true;
      },
      hideImageView(){
        this.showBig = false;
      },
    }
  }
</script>

<style lang="scss">
  .bill-list{
    text-align: left;
    margin-right: 0.3rem;
    margin-left: 0.3rem;
    .bill-item{
      padding-bottom: 0.3rem;
      padding-right: 0.3rem;
      padding-top: 0.3rem;
      border-bottom: solid 1px #d5dee2
    }
    .bill-info{
      display: flex;
      justify-content: space-between
    }
    .bill-name{
      color: #1b1e29;
      font-size: 0.22rem
    }
    .bill-status-uncreate{
      color: #808a9a;
    }
    .bill-status-prepay{
      color: #ff7544;
    }
    .bill-status-paid{
      color: #1d8ae7;
    }
    .bill-amount{
      font-size: 0.56rem;
      color: #ff7544
    }
  }
  .confirm-payment{
    background: white;
    font-size: 0.28rem;
    .color-gray{
      color: #878E99;
    }
    .color-black{
      color: #1B1E29;
    }
    .color-blue{
      color: #1D8AE7;
    }
    .color-orange{
      color: #FF7544;
    }
    .border-top-0{
      border-top: 0 !important;
    }
    .border-top-style{
      border-top: solid 1px #d5dee2;
    }
    .clear-header{
      margin-top: -1rem;
    }
    .payment{
      width: calc(100% - 0.56rem);
      padding: 0.5rem 0.28rem 0.1rem;
      background-color: white;
      text-align: left;

    .payment-box{
      padding: 0.66rem 0.46rem 0.44rem 0.44rem;
      box-shadow: 0 0 10px 1px rgba(29, 138, 231, 0.5);
      color: #1B1E29;

      .pb-money{
        color: #878E99;

        .pb-money-row{
          display: flex;
          line-height: 0.28rem;

          .row-left{
            width: 4.05rem;
            height: 0.82rem;
            display: flex;
            align-items: flex-end;
            border-right: solid 0.02rem #D5DEE2;

            .ratio{
              margin-right: 0.5rem;
              max-width: 2.5rem;
              min-width: 2.5rem;
            }

            .money{
              font-size: 0.32rem;
              line-height: 0.32rem;
            }
          }
          .row-right{
            flex-grow: 1;
            display: flex;
            justify-content: center;
            align-items: flex-end;
            text-align: center;
            margin-right: -0.3rem;
          }
        }
      }

      .payment-btn{
        width: 1.69rem;
        height: 0.61rem;
        margin-top: 0.5rem;
        line-height: 0.61rem;
        background-color: #1D8AE7;
        border-radius: 0.4rem;
        font-size: 0.28rem;
        color: white;
        text-align: center;
        float: right;
      }
    }
  }
  .pb-money-row-style{
    .row-left{
      height: 0.32rem !important;
    }
  }

  .pay-mode{
    background-color: white;
    width: calc(100% - 0.28rem);
    padding-left:0.28rem;

    .mode-row{
      height: 0.96rem;
      width: calc(100% - 0.28rem);
      padding-right:0.28rem;
      display: flex;
      align-items: center;

      .icon{
        width: 0.37rem;
        height: 0.38rem;
        margin-right: 0.3rem;
      }

      .row-text-right{
        flex-grow: 1;
        text-align: right;
      }
      .row-money{
        flex-grow: 1;
        text-align: right;
      }

      .money{
        font-size: 0.32rem;
      }
      }
    }
    .btns{
      background-color: white;
      padding-top:0.5rem;
      padding-bottom:1.28rem;
      display: flex;
      justify-content: center;
      width: 100%;
      .cancel-btn{
        width: 1.68rem;
        height: 0.6rem;
        line-height: 0.6rem;
        border: solid 0.01rem #D5DEE2;
        border-radius: 0.4rem;
        color: #1B1E29;
        text-align: center;
        margin-right: 0.82rem;
      }

      .payment-btn{
        width: 2.02rem;
        height: 0.6rem;
        line-height: 0.6rem;
        background-color: #1D8AE7;
        border-radius: 0.4rem;
        color: white;
        text-align: center;
      }
    }
    .image-area {
      background-color: #fff;
      width: 100%;

      .image-view {
        display: flex;
        flex-flow: row wrap;
        padding-bottom: 0.2rem;
        padding-left:36px;

        .image {
          width: 1.64rem;
          height: 1.64rem;
          background: #F3F8FC;
          margin-bottom: 5px;
          margin-right: 14px;

          &.add-image {
            display: flex;
            flex-flow: row wrap;
            justify-content: center;
            align-items: center;
            color: #999;
          }

          .icon-plus img {
            width: 0.8rem;
            height: 0.8rem;
            position: relative;
          }

          img {
            width: 100%;
            height: 100%;
          }

        }
      }
    }
    .big-img-container{
      display: flex;
      width: 100%;
      height: 100%;
      position: fixed;
      background:rgba(0,0,0,0.8);
      z-index:1000;
      top: 0;
      left: 0;
      flex-direction: column;
      justify-content: center;
      .big-img {
        width: 100%;
        position:fixed;
        z-index: 10001;
      }
      .hidden-tip{
        font-size: 0.2rem;
        color: white;
        height: 0.5rem;
        line-height: 0.55rem;
        width: 1.6rem;
        text-align: center;
        border-radius: 0.4rem;
        z-index: 10001;
        background-color: rgba(0,0,0,0.4);
        position: absolute;
        left: 35%;
        bottom: 0.8rem
      }
    }
  }
</style>
